import React from 'react';
import { ButtonBase } from '@mui/material';

export const BigButton = ({icon, onClick, selected, title}) => (
  <ButtonBase className={selected ? "big-button-base selected" : "big-button-base"} onClick={onClick}>
    <div className="big-button-icon">
      <img src={icon} />
    </div>
    <div>
      <span>{title}</span>
    </div>
  </ButtonBase>
)
